<template>
  <div
    class="BaseTemplateMain hide-scrollbar"
    :class="
      !hasPrinter
        ? 'q-pa-md q-pt-lg-lg q-px-lg-xl bg-off-white-10 flex-1 flex justify-center scroll'
        : 'BaseTemplateMain--printer'
    "
  >
    <div
      class="shadow-2 bg-white BaseTemplateMain__receipt relative-position"
      :class="[
        templateStore.isDigitalMenu
          ? [templateStore.isVertical ? 'BaseTemplateMain__digital-menu' : 'BaseTemplateMain__digital-menu--landscape']
          : '',
      ]"
      :style="`width: ${templateStore.templateWidth}px;`"
    >
      <BaseTemplateMainSection
        v-for="(layer, layerIndex) in templateStore.layers"
        :key="layerIndex"
        :layer="layer"
        :layer-index="layerIndex"
        :has-printer="hasPrinter"
      />
    </div>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'
import BaseTemplateMainSection from './BaseTemplateMainSection'

defineOptions({ name: 'BaseTemplateMain' })

defineProps({ hasPrinter: { type: Boolean, default: false } })

const templateStore = useTemplateStore()
</script>

<style lang="sass" scoped>
@import 'src/shared/styles/variables.sass'
@import 'src/shared/styles/mixins.sass'

.BaseTemplateMain
  padding-bottom: 101px
  @include state-modifier('printer')
    padding-bottom: 0
  @include element('receipt')
    height: fit-content

  @include element('digital-menu')
    aspect-ratio: 9 / 16
    overflow: hidden
    @include state-modifier('landscape')
      aspect-ratio: 16 / 9
      overflow: hidden
</style>
